module.exports = __webpack_public_path__ + "static/media/61.295cef8a.png";